// extracted by mini-css-extract-plugin
export default {"table":"_98bSS"};